import React from 'react';
import { InputNumber } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

export const NumberInput = ({ 
  label,
  error,
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  ...props 
}) => {
  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <InputNumber
        status={error ? 'error' : ''}
        style={{ width: '100%' }}
        {...props}
      />
    </InputWrapper>
  );
};

NumberInput.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
};

export default NumberInput; 